var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99927 4.8125H8.24927C8.24927 3.03938 6.52739 2.23063 5.12427 2.04438V0.75H3.87427V2.04438C2.47114 2.23063 0.749268 3.03938 0.749268 4.8125C0.749268 6.50375 2.41552 7.38313 3.87427 7.58125V10.6875C2.96927 10.5306 1.99927 10.0475 1.99927 9.1875H0.749268C0.749268 10.8056 2.26489 11.7619 3.87427 11.96V13.25H5.12427V11.9563C6.52739 11.77 8.24927 10.9606 8.24927 9.1875C8.24927 7.41438 6.52739 6.60563 5.12427 6.41937V3.3125C5.95552 3.46187 6.99927 3.90062 6.99927 4.8125ZM1.99927 4.8125C1.99927 3.90062 3.04302 3.46187 3.87427 3.3125V6.31188C3.01739 6.15375 1.99927 5.68563 1.99927 4.8125ZM6.99927 9.1875C6.99927 10.0994 5.95552 10.5381 5.12427 10.6875V7.6875C5.95552 7.83688 6.99927 8.27563 6.99927 9.1875Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.0005420569a80da753aafbe41804a849.svg";
export { ForwardRef as ReactComponent };